var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "prevent-scroll",
          rawName: "v-prevent-scroll",
          value: _vm.lockScroll,
          expression: "lockScroll"
        }
      ],
      staticClass: "sui-popup"
    },
    [
      _c("transition", { attrs: { name: "sui-transition-fade" } }, [
        _c("div", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.visiable,
              expression: "visiable"
            }
          ],
          staticClass: "sui-popup-mask",
          class: {
            "sui-popup-mask--transparent": _vm.transparentMask,
            "sui-popup-mask--noMask": !_vm.hasMask
          },
          on: { click: _vm.closePopup }
        })
      ]),
      _vm._v(" "),
      _vm.type === "center"
        ? _c("transition", { attrs: { name: "sui-transition-fade" } }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.visiable,
                    expression: "visiable"
                  }
                ],
                staticClass: "sui-popup-main sui-popup-main--center"
              },
              [
                _c(
                  "div",
                  { staticClass: "sui-popup-main-content" },
                  [_vm._t("default")],
                  2
                )
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.type === "bottom"
        ? _c("transition", { attrs: { name: "sui-transition-slideBottom" } }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.visiable,
                    expression: "visiable"
                  }
                ],
                staticClass: "sui-popup-main sui-popup-main--bottom"
              },
              [_vm._t("default")],
              2
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.type === "top"
        ? _c("transition", { attrs: { name: "sui-transition-slideTop" } }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.visiable,
                    expression: "visiable"
                  }
                ],
                staticClass: "sui-popup-main sui-popup-main--top"
              },
              [_vm._t("default")],
              2
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.type === "left"
        ? _c("transition", { attrs: { name: "sui-transition-slideLeft" } }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.visiable,
                    expression: "visiable"
                  }
                ],
                staticClass: "sui-popup-main sui-popup-main--left"
              },
              [_vm._t("default")],
              2
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.type === "right"
        ? _c("transition", { attrs: { name: "sui-transition-slideRight" } }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.visiable,
                    expression: "visiable"
                  }
                ],
                staticClass: "sui-popup-main sui-popup-main--right"
              },
              [_vm._t("default")],
              2
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }